import Utils from '../../services/utils';

export const taxesValueLabelList = [
  { value: '01', label: 'IVA', percent: 19 },
  { value: '02', label: 'IC', percent: 19 },
  { value: '03', label: 'ICA', percent: 19 },
  { value: '04', label: 'INC', percent: 19 },
  { value: '05', label: 'ReteIVA', percent: 19 },
  { value: '06', label: 'ReteFuente', percent: 19 },
  { value: '07', label: 'ReteICA', percent: 19 },
  { value: '08', label: 'ReteCREE', percent: 19 },
  { value: '20', label: 'FtoHorticultura', percent: 19 },
  { value: '21', label: 'Timbre', percent: 19 },
  { value: '22', label: 'Bolsas', percent: 19 },
  { value: '23', label: 'INCarbono', percent: 19 },
  { value: '24', label: 'INCombustibles', percent: 19 },
  { value: '25', label: 'Sobretasa Combustibles', percent: 19 },
  { value: '26', label: 'Sordicom', percent: 19 }
];

export const taxesLabelsObject = Utils.valueLabelListToLabelsObject(taxesValueLabelList);
